@let currentSteps = steps();

<div class="tutorial__backdrop" (click)="dismiss()"></div>

<div class="tutorial">
  <div class="tutorial__header">
    <div class="tutorial__header-left">
      <fa-duotone-icon [icon]="faShieldKeyhole" class="tutorial__shield-icon"></fa-duotone-icon>
      <div class="tutorial__header-text">
        <h3 class="tutorial__title">{{ 'Permission blocked' | translate }}</h3>
        <p class="tutorial__subtitle">
          {{ 'Your browser has blocked access to your' | translate }}
          {{ deviceLabel() | translate }}.
          {{ 'Follow these steps to allow access.' | translate }}
        </p>
      </div>
    </div>
    <button class="tutorial__close" (click)="dismiss()" [title]="'Close' | translate">
      <fa-duotone-icon [icon]="faXmark"></fa-duotone-icon>
    </button>
  </div>

  <div class="tutorial__steps" [class.tutorial__steps--many]="currentSteps.length > 2">
    @for (s of currentSteps; track $index) {
      <div class="tutorial__step">
        <div class="tutorial__step-number">{{ $index + 1 }}</div>
        <div class="tutorial__step-body">
          <div class="tutorial__image-container">
            <img
              [src]="s.image"
              [alt]="s.title"
              class="tutorial__image"
              (error)="$event.target.style.display='none'" />
            <div class="tutorial__image-placeholder">
              <fa-duotone-icon [icon]="faArrowPointer"></fa-duotone-icon>
            </div>
          </div>
          <h4 class="tutorial__step-title">{{ s.title | translate }}</h4>
          <p class="tutorial__step-desc">{{ s.description | translate }}</p>
        </div>
      </div>
    }
  </div>

  <div class="tutorial__footer">
    <button class="tutorial__continue-btn" (click)="dismiss()">
      {{ continueLabel() | translate }}
    </button>
  </div>
</div>
